<template>
  <component
    :is="withCard ? 'el-card' : 'div'"
    ref="card"
    :class="{ 'compact-detail': !withCard }"
  >
    <el-descriptions
      title="表头信息"
      :column="3"
      :size="withCard ? '' : 'mini'"
      border
    >
      <el-descriptions-item label="核注业务单号">{{
        info.copListNo
      }}</el-descriptions-item>
      <el-descriptions-item label="海关清单编号">{{
        info.businessId
      }}</el-descriptions-item>
      <el-descriptions-item label="单一窗口号">{{
        info.singleWindowNo
      }}</el-descriptions-item>
      <el-descriptions-item label="账册号">{{
        info.emsNo
      }}</el-descriptions-item>
      <el-descriptions-item label="清单类型">{{
        info.billType
      }}</el-descriptions-item>
      <el-descriptions-item label="申报状态">{{
        info.status
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业名称">{{
        info.bizOpCompanyName
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业编号">{{
        info.bizOpCompanyNo || info.bizOpCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业社会信用代码">{{
        info.bizOpCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业名称">{{
        info.rcvCompanyName
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业编号">{{
        info.rcvCompanyNo || info.rcvCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业社会信用代码">{{
        info.rcvCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业名称">{{
        info.dclCompanyName
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业编号">{{
        info.dclCompanyNo || info.dclCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业社会信用代码">{{
        info.dclCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="监管方式">{{
        info.tradeMode
      }}</el-descriptions-item>
      <el-descriptions-item label="运输方式">{{
        info.transMode
      }}</el-descriptions-item>
      <el-descriptions-item label="起运国">{{
        info.startShipCountry
      }}</el-descriptions-item>
      <el-descriptions-item label="关联账册备案编号">{{
        info.rltEmsNo
      }}</el-descriptions-item>
      <el-descriptions-item label="关联清单编号">{{
        info.rltInvtNo
      }}</el-descriptions-item>
      <el-descriptions-item label="状态描述">{{
        info.statusDesc
      }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      title="表体信息"
      style="margin-top: 20px;"
    ></el-descriptions>
    <el-table
      :data="goods"
      :size="withCard ? '' : 'mini'"
      :max-height="withCard ? undefined : '40vh'"
    >
      <el-table-column
        prop="listGNo"
        label="商品序号"
        width="100"
      ></el-table-column>
      <el-table-column prop="gno" label="备案序号" />
      <el-table-column prop="copGNo" label="商品料号" width="250" />
      <el-table-column prop="codeTs" label="商品编码" width="150" />
      <el-table-column prop="gName" label="商品名称" width="150" />
      <el-table-column prop="gModel" label="商品规格型号" width="200" />
      <el-table-column prop="unit" label="申报计量单位" width="150" />
      <el-table-column prop="unit1" label="法定计量单位" width="150" />
      <el-table-column prop="unit2" label="法定第二单位" width="150" />
      <el-table-column prop="countryCode" label="原产国(地区)" width="150" />
      <el-table-column prop="decPrice" label="企业申报单价" width="150" />
      <el-table-column prop="decTotal" label="企业申报总价" width="150" />
      <el-table-column prop="factor1" label="法定数量" width="150" />
      <el-table-column prop="factor2" label="第二法定数量" width="150" />
      <el-table-column prop="qty" label="申报数量" width="150" />
      <el-table-column prop="curr" label="币制" width="150" />
      <el-table-column prop="entGNo" label="报关单商品序号" width="150" />
      <el-table-column prop="grossWt" label="毛重" width="150" />
      <el-table-column prop="netWt" label="净重" width="150" />
    </el-table>
  </component>
</template>

<script>
import heZhuApi from "@/api/heZhuApi";

export default {
  props: {
    hezhuOrderId: { type: String, default: "" },
    withCard: { type: Boolean, default: true }
  },
  data() {
    return {
      info: {},
      goods: []
    };
  },
  created() {
    this.fetch(this.hezhuOrderId || this.$route.params.heZhuOrderId);
  },
  watch: {
    hezhuOrderId(id) {
      if (id) this.fetch(id);
    },
    $route(to, from) {
      if (this.hezhuOrderId) return;
      if (to.name === "heZhuOrderDetail") {
        this.fetch(this.$route.params.heZhuOrderId);
      }
    }
  },
  methods: {
    fetch(heZhuOrderId) {
      this.info = {};
      this.goods = [];
      heZhuApi.load({ heZhuOrderId }).then(res => {
        this.info = res;
        this.goods = res.items || [];
      });
    }
  }
};
</script>

<style scoped>
.compact-detail /deep/ .el-descriptions__header {
  margin-bottom: 12px;
}
.compact-detail /deep/ .el-descriptions__title {
  font-size: 14px;
}
.compact-detail /deep/ .el-table {
  font-size: 12px;
}
.compact-detail /deep/ .el-table .cell {
  line-height: 18px;
}
</style>
